import { Grid } from '@mui/system';
import { HEALTHCHECK_NAMES } from 'domain/shared/newProject';
import HealthcheckRow from '../HealthcheckRow';
import { getHealthcheckByName, HealthcheckMessage } from '../../shared/healthcheck';
import { HEALTHCHECK_LABELS } from '../commercial/constants';
import { ProductionOwnership } from '../../engineering/types';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';
import { ControlData } from '../types';

type EngineeringHealthchecksProps = {
  data: ControlData;
};

const EngineeringHealthchecks = ({ data }: EngineeringHealthchecksProps) => {
  const healthChecks = data?.health?.healthChecks || [];

  const { isFeatureEnabled } = useFeatureToggle();
  const engineeringLinkHealthcheck = getHealthcheckByName(healthChecks, HEALTHCHECK_NAMES.ENGINEERING_LINK);
  const engineeringSetupHealthcheck = getHealthcheckByName(healthChecks, HEALTHCHECK_NAMES.ENGINEERING_SETUP);
  const engineeringIncidentsHealthcheck = getHealthcheckByName(healthChecks, HEALTHCHECK_NAMES.ENGINEERING_INCIDENTS);
  const engineeringBugsHealthcheck = getHealthcheckByName(healthChecks, HEALTHCHECK_NAMES.ENGINEERING_BUGS);
  const risksHealthcheck = getHealthcheckByName(healthChecks, HEALTHCHECK_NAMES.ENGINEERING_RISKS);

  return (
    <Grid container direction={'column'} size={12} pl={2}>
      {isFeatureEnabled(Features.NEW_PROJECT_ENGINEERING) && (
        <>
          <HealthcheckRow label={HEALTHCHECK_LABELS.PPC} lastUpdateValue={engineeringLinkHealthcheck?.zoneSince}>
            <HealthcheckMessage healthcheck={engineeringLinkHealthcheck} />
          </HealthcheckRow>
          <HealthcheckRow
            label={HEALTHCHECK_LABELS.PRODUCTION_OWNERSHIP}
            lastUpdateValue={
              engineeringSetupHealthcheck?.latestEntityModificationDate ?? engineeringSetupHealthcheck?.zoneSince
            }
          >
            <HealthcheckMessage healthcheck={engineeringSetupHealthcheck} />
          </HealthcheckRow>
          {data?.engineeringPolicy?.productionOwnership === ProductionOwnership.OUR_TEAM && (
            <>
              <HealthcheckRow
                label={HEALTHCHECK_LABELS.PRODUCTION_INCIDENTS}
                lastUpdateValue={
                  engineeringIncidentsHealthcheck?.latestEntityModificationDate ??
                  engineeringIncidentsHealthcheck?.zoneSince
                }
              >
                <HealthcheckMessage healthcheck={engineeringIncidentsHealthcheck} />
              </HealthcheckRow>
              <HealthcheckRow
                label={HEALTHCHECK_LABELS.PRODUCTION_BUGS}
                lastUpdateValue={
                  engineeringBugsHealthcheck?.latestEntityModificationDate ?? engineeringBugsHealthcheck?.zoneSince
                }
              >
                <HealthcheckMessage healthcheck={engineeringBugsHealthcheck} />
              </HealthcheckRow>
            </>
          )}
        </>
      )}
      <HealthcheckRow label={HEALTHCHECK_LABELS.RISKS} lastUpdateValue={risksHealthcheck?.zoneSince}>
        <HealthcheckMessage healthcheck={risksHealthcheck} />
      </HealthcheckRow>
    </Grid>
  );
};

export default EngineeringHealthchecks;
